import { CommonModule } from "@angular/common";
import { Component, inject, input } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

@Component({
  standalone: true,
  selector: "free-bets-total",
  templateUrl: "free-bets-total.component.html",
  styleUrls: ["free-bets-total.component.scss"],
  imports: [IonicModule, CommonModule, TranslateModule, ReactiveFormsModule, FormsModule],
})
export class FreeBetsTotal {
  aPendingFBLength = input.required<number>();
  activeFBLength = input.required<number>();
  translate = inject(TranslateService);
}
